import React, { useState, useContext, useEffect } from 'react';
import { Redirect } from 'react-router-dom';

import { get, post, put } from '../../api';
import UserModel from '../../models/user';
import { AuthContext } from '../../contexts/Auth';
import CustomerContext from '../../contexts/Customer';
import { CUSTOMER_USER } from '../../constants/roles';
import { normalizePermissions } from '../../helpers/user';

import UserInfoForm from '../../components/UserInfoForm';
import FrameHeader from '../../components/FrameHeader';

// import styles from './NewCustomerUser.module.scss';

export default function NewCustomerUser({ match: { params } }) {
  const { state } = useContext(AuthContext);
  const { customer } = useContext(CustomerContext);
  const [saving, setSaving] = useState(false);
  const [redirect, setRedirect] = useState(false);
  const [groups, setGroups] = useState([]);

  useEffect(() => {
    let cancelled = false;
    async function loadGroups() {
      if (!state.user.customer_id) return;
      const res = await get('/groups', {
        orderBy: '-created_time',
        customer_id: state.user.customer_id,
        include_users: '1',
      });
      if (cancelled) return;
      const list = res?.results ? [...res.results] : [];
      list.sort((a, b) =>
        a.name.toLowerCase().localeCompare(b.name.toLowerCase())
      );
      setGroups(list);
    }
    loadGroups();
    return () => {
      cancelled = true;
    };
  }, [state.user.customer_id]);

  const createUser = async (user, perms, { groupsToAdd = [] } = {}) => {
    setSaving(true);

    const res = await post('/users', {
      ...user,
      tenant_id: customer.tenant_id,
      customer_id: state.user.customer_id,
      authority: CUSTOMER_USER
    });

    if (!res?.id) {
      alert('Sorry, unable to create selected user.');
      setSaving(false);
      return;
    }

    await put(`/users/${res.id}/permissions`, {
      permissions: normalizePermissions(perms)
    });

    const relationBase = {
      from_type: 'GROUP',
      to_id: res.id,
      to_type: 'USER',
      relation_type_group: 'COMMON',
    };

    for (const group of groupsToAdd) {
      let groupId = group.id;
      if (groupId === 0 || groupId === '0') {
        const gRes = await post('/groups', {
          name: group.name,
          tenant_id: customer.tenant_id,
          customer_id: state.user.customer_id,
        });
        groupId = gRes?.id;
      }
      if (groupId) {
        await post('/relations', {
          ...relationBase,
          from_id: groupId,
        });
      }
    }

    await post('/users/sendActivationMail', {
      email: res.email
    });

    setRedirect(`/customer/users`);
    setSaving(false);
  };

  return redirect ? (
    <Redirect to={redirect} />
  ) : (
    <>
      <FrameHeader title="New user" />

      <UserInfoForm
        state={UserModel}
        groups={groups}
        saving={saving}
        onSave={createUser}
        isNew
      />
    </>
  );
}
